module.exports = __webpack_public_path__ + "img/mickey60.c38f34cd.jpg";